var _tspan;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeaWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.76,55.7a6.94,6.94,0,0,1,5.34-3.05A8.24,8.24,0,0,1,23,54.57",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.16,53.51a6.84,6.84,0,0,1-5.43,2.83A8.07,8.07,0,0,1,50.93,55",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.63,53.83a8.73,8.73,0,0,0-5.88-2.16,7.69,7.69,0,0,0-5.42,2.83,7.42,7.42,0,0,1-5.43,2.82A7.93,7.93,0,0,1,26.1,56",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.42,62.07A6.81,6.81,0,0,1,59,64.9a9.55,9.55,0,0,1-5.78-1.51l-1.86-1.2A7.68,7.68,0,0,0,45.6,60.3c-3,.13-5.43,2.83-5.43,2.83a8.06,8.06,0,0,1-6,2.94,9.61,9.61,0,0,1-4.78-1.21l-3.09-1.79a10.33,10.33,0,0,0-5.87-1.86A6.54,6.54,0,0,0,15,64",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.25,72.59a6.83,6.83,0,0,1,5.43-2.82,8.3,8.3,0,0,1,5.88,2.16",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.69,70.63a6.81,6.81,0,0,1-5.42,2.83,8.12,8.12,0,0,1-4.81-1.34",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.17,71a8.73,8.73,0,0,0-5.88-2.16,8.4,8.4,0,0,0-5.43,2.82,8.09,8.09,0,0,1-5.42,2.83,7.92,7.92,0,0,1-4.81-1.34",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.14,38.16c0,6.8-4.53,15.78-15.69,15.78S22.77,45,22.77,38.16c0-11.82,15.68-28.1,15.68-28.1S54.14,26.34,54.14,38.16Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "#fff",
      stroke: "currentColor",
      strokeWidth: "1.8px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.76,47.41a8.58,8.58,0,0,1-7.25-.7,8.73,8.73,0,0,1-4.76-5.58",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.7px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(-0.01 -4.78)",
    style: {
      fontSize: 10,
      fill: "currentColor",
      fontFamily: "ArialMT, Arial"
    }
  }, "Sea ", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 20.57,
    y: 0,
    style: {
      letterSpacing: "-0.04em"
    }
  }, "W"), _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 29.64,
    y: 0
  }, "ater")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeaWater);
export default __webpack_public_path__ + "static/media/sea_water.4436d0b8215c1c0bda75a047eefea71d.svg";
export { ForwardRef as ReactComponent };